import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { BrandMarquee } from "@/components/landing/BrandMarquee";
import { PainPoints } from "@/components/landing/PainPoints";
import { Solutions } from "@/components/landing/Solutions";
import { Process } from "@/components/landing/Process";
import { About } from "@/components/landing/About";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { ContactForm } from "@/components/landing/ContactForm";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="bg-warm-neutral text-navy-900 antialiased">
      <Header />
      <main>
        <Hero />
        <BrandMarquee />
        <PainPoints />
        <Solutions />
        <Process />
        <About />
        <FAQ />
        <FinalCTA />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
